export default [
  { label: 'She/Her', value: 'she' },
  { label: 'He/Him', value: 'he' },
  { label: 'They/Them', value: 'they' },
];
